import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "-1"
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "1"
    }
  }, [_vm._v("待审核")]), _c("el-radio-button", {
    attrs: {
      label: "2"
    }
  }, [_vm._v("在线中")]), _c("el-radio-button", {
    attrs: {
      label: "3"
    }
  }, [_vm._v("已过期")]), _c("el-radio-button", {
    attrs: {
      label: "4"
    }
  }, [_vm._v("已拒绝")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "会员类型"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "type", $$v);
      },
      expression: "searchForm.type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: -1
    }
  }), _c("el-option", {
    attrs: {
      label: "房客会员",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "房东会员",
      value: 2
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "会员开始时间"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      "value-format": "timestamp"
    },
    model: {
      value: _vm.searchForm.start_time,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "start_time", $$v);
      },
      expression: "searchForm.start_time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "会员结束时间"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      "value-format": "timestamp"
    },
    model: {
      value: _vm.searchForm.end_time,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "end_time", $$v);
      },
      expression: "searchForm.end_time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "证件名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.auth_name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "auth_name", $$v);
      },
      expression: "searchForm.auth_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          status: -1,
          type: -1
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")]), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.auditMemberUser
    }
  }, [_vm._v("批量审核")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "姓名",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          auth_info = _ref$row.auth_info,
          userScore = _ref$row.userScore,
          deviceRiskInfo = _ref$row.deviceRiskInfo;
        return [auth_info.card_type > 0 ? _c("el-tag", {
          attrs: {
            type: "warning",
            size: "mini"
          }
        }, [_vm._v("非大陆用户")]) : _vm._e(), _c("wlc-user-pop", {
          attrs: {
            info: userInfo,
            deviceRisk: "",
            deviceRiskInfo: deviceRiskInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        }), _c("wlc-pop-radar-chart", {
          attrs: {
            info: userScore,
            type: 0
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "会员状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 1 ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("待审核")]) : _vm._e(), scope.row.status == 2 ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("在线中")]) : _vm._e(), scope.row.status == 3 ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("已过期")]) : _vm._e(), scope.row.status == 4 ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("已拒绝")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "会员类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type == 1 ? _c("span", [_vm._v("房客")]) : _vm._e(), scope.row.type == 2 ? _c("span", [_vm._v("房主")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.user.remark_log,
            remark: scope.row.user.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "实名信息",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.auth_info.card_type > 0 ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "success"
          },
          on: {
            click: function click($event) {
              return _vm.realNameInfoDialog(scope.row);
            }
          }
        }, [_vm._v("查看")]) : _c("el-popover", {
          attrs: {
            placement: "top-start",
            content: scope.row.auth_info.idcard_number,
            trigger: "hover"
          }
        }, [_c("el-link", {
          attrs: {
            slot: "reference",
            type: "primary"
          },
          nativeOn: {
            click: function click($event) {
              return _vm.gotoRealName(scope.row);
            }
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.auth_info.idcard_name) + " "), scope.row.auth_info.total > 1 ? _c("span", [_vm._v(" * " + _vm._s(scope.row.auth_info.total))]) : _vm._e()])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "手机",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user.is_virtual_number ? _c("el-tag", {
          staticClass: "mr8 wlc-important-tag",
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("虚拟号")]) : _vm._e(), _c("div", [_vm._v(_vm._s(scope.row.user.phone))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "amount",
      label: "原价",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return row !== null && row !== void 0 && row.order ? [row.order.is_coupon == 1 ? _c("span", [_vm._v(_vm._s(Number(row.order.amount) + Number(row.order.coupon_balance)))]) : row.order.coupon_id ? _c("span", [_vm._v(_vm._s(Number(row.order.amount) + Number(row.order.coupon_amount)))]) : _c("span", [_vm._v(_vm._s(Number(row.order.amount)))]), row.order.is_coupon == 1 ? _c("el-tag", {
          staticStyle: {
            "margin-left": "6px"
          },
          attrs: {
            type: "primary",
            size: "mini"
          }
        }, [_vm._v("抵用金")]) : _vm._e(), row.order.coupon_id ? _c("el-tag", {
          staticStyle: {
            "margin-left": "6px"
          },
          attrs: {
            type: "success",
            size: "mini"
          }
        }, [_vm._v("优惠券")]) : _vm._e()] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      label: "用户标签",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.user_id,
            list: scope.row.userTag
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "聊天人数",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.im_count,
            userId: scope.row.user_id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.created_at",
      label: "注册时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "start_time",
      label: "开始时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "end_time",
      label: "结束时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "退款记录",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.refund_num) + "次 ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "160",
      align: "center",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 1 ? _c("el-button", {
          staticClass: "wlc-button-succes",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.auditMemberUser(scope.row, 2);
            }
          }
        }, [_vm._v("通过 ")]) : _vm._e(), scope.row.status == 1 ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.auditMemberUser(scope.row, 4);
            }
          }
        }, [_vm._v("拒绝 ")]) : _vm._e(), scope.row.status == 1 ? _c("br") : _vm._e(), scope.row.status == 2 ? _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.cancelMember(scope.row);
            }
          }
        }, [_vm._v("取消会员 ")]) : _vm._e(), _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row.user);
            }
          }
        }, [_vm._v(" 备注 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.count,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "实名信息",
      width: "600px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "90px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "证件类型"
    }
  }, [_vm.authInfo.card_type == 0 ? _c("span", [_vm._v("大陆居民")]) : _vm._e(), _vm.authInfo.card_type == 1 ? _c("span", [_vm._v("港澳居民往来通行证")]) : _vm._e(), _vm.authInfo.card_type == 2 ? _c("span", [_vm._v("台湾居民往来通行证")]) : _vm._e(), _vm.authInfo.card_type == 3 ? _c("span", [_vm._v("外国护照")]) : _vm._e()]), _c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_vm._v(" " + _vm._s(_vm.authInfo.idcard_name) + " ")]), _c("el-form-item", {
    attrs: {
      label: "证件号码"
    }
  }, [_vm._v(" " + _vm._s(_vm.authInfo.idcard_number) + " ")]), _vm.authInfo.card_img && _vm.authInfo.card_img.length ? _c("el-form-item", {
    attrs: {
      label: "手持证件照"
    }
  }, _vm._l(_vm.authInfo.card_img, function (item, index) {
    return _c("wlc-image", {
      key: item,
      attrs: {
        width: "100px",
        height: "100px",
        enlarged: false,
        src: item
      },
      nativeOn: {
        click: function click($event) {
          return _vm.handlePicturePreview(index);
        }
      }
    });
  }), 1) : _vm._e()], 1)], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };